import "../styles.scss";

import {
  AreaChartOutlined,
  CloudUploadOutlined,
  CopyOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  ExportOutlined,
  EyeOutlined,
  FormOutlined,
  InfoCircleOutlined,
  LoadingOutlined,
  PictureOutlined,
  RollbackOutlined,
  SettingOutlined,
  ShareAltOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Radio } from "antd";
import { notification, Spin } from "antd";
import axios from "axios";
import { noDownloadStreams } from "constants/v2/streamConstants";
import { createDownloadLink, createPresignedDownloadLink } from "helpers";
import FileDownload from "js-file-download";
import _, { get } from "lodash";
import React, { useCallback, useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { useNavigate, useOutletContext } from "react-router-dom";
import { getDataFeedStatsPerformMetadata } from "store/dataFeed/actions.js";
import { aspectRatioCheckForIllusto } from "utils/illusto";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import ShowCSV from "../../../components/common/ClipsFilter/partials/ShowCsvModal";
import CommonJsonContext from "../../../components/common/CommonJsonViewer/commonJsonContext";
import CommonJsonDetails from "../../../components/common/CommonJsonViewer/commonJsonDetails";
import AlertDialog from "../../../components/common/Modals/AlertDialog";
import DeleteModal from "../../../components/common/Modals/component";
import {
  ASPECT_RATIO,
  EVENT_NAME,
  ROLE,
  STREAM_STATUS,
  STREAM_STATUS_MAP,
  SUPPORTED_ASPECTRATIO_FOR_SHOT_UPLOAD,
  SYNCING_STATUS,
  ZEE_CATEGORY_TYPES,
  ZEE_CLIENT,
} from "../../../constants/phase";
import { ENTITY_TYPE } from "../../../constants/phase";
import { SocketContext } from "../../../context/socket";
import amplitude from "../../../externals/amplitude";
import IllustoAdvEditorLogo from "../../../images/illusto-advance-editor.svg";
import { fetchClipMetadata } from "../../../store/videogrid/api.js";
import ChangeThumbNail from "./ChangeThumbNail";
import CopyClip from "./CopyClip";
import CopyClipToChild from "./CopyClipToChild";
import EditClip from "./EditClip";
import SocialMediaCaption from "./generateSocialMediaCaption";
import GenerateTitle from "./GenerateTitle";
import MetadataModal from "./MetadataModal";
import ModalPublish from "./ModalPublish";
import PublishThumbNailModal from "./PublishThumbnail";
import PublishToCMS from "./PublishToCMS";
import ShowClipTitle from "./ShowClipTitle";
import TrimClip from "./TrimClip";
import UploadToFTP from "./UploadToFTP";
import UploadTOS3 from "./UploadToS3";
import UploadToZee from "./UploadToZee";
import VideoSpeed from "./VideoSpeed";
const TableAction = ({ ...props }) => {
  const {
    id,
    updatesftp,
    clip,
    step,
    deleteClips,
    copyClip,
    editClip,
    allClips,
    allClipsForCms,
    publishClip,
    streamDetails,
    getTrimClip,
    fetchStorage,
    s3BucketPublish,
    bulkS3BucketPublish,
    jsonBucketPublish,
    storage,
    folderArray,
    setFolderArray,
    clipExportJson,
    clipExportEDL,
    clipExportXml,
    user,
    dumpOnS3,
    ftpPublish,
    bucketCopy,
    clientWebHookPublish,
    fetchUserDetails,
    copyClipToReviewer,
    getPublicUrls,
    uploadClipInBrightCove,
    fetchBrightCoveToken,
    getCustomFields,
    fetchUsersByUserIds,
    allUsers,
    clientSetting,
    addThumbnail,
    getUploadPicture,
    updateClipDetails,
    GenerateVideoTitle,
    singleClipDetail,
    s3Open,
    ftpOpen,
    ftpList,
    setFTPOpen,
    setS3Open,
    shareOnSocialMedias,
    aspectRatio,
    getCloudPreSignedURL,
    getDataFeedStatsPerformMetadata,
    filters,
    addSocialMediaData,
    addPublishNotification,
    refreshClips,
    handleSteps,
    advanceEditorIllusto,
    genrateNewClip,
    getStreamDetail,
    getCsvData,
    createSocialMediaCaption,
    downloadClipZipPackage,
    publishZeeThumbnails,
    registerAryshareWebhook,
    regenerateThumbnail,
    getSocialProfiles,
    getDownloadVideo,
    getDownloadVideoStatus,
    entityType,
  } = props;
  const antIcon = <LoadingOutlined style={{ fontSize: 24, align: "center" }} spin />;
  const navigate = useNavigate();
  const { getDownloadStatus, entityId, currentRole, organizations, selectedEntity } = useOutletContext();
  const { webhookSocket } = useContext(SocketContext);
  const [delmodalOpen, setDeleteModalOpen] = useState(false);
  const [thumbModelOpen, setThumbModalOpen] = useState(false);
  const [userId, setUserId] = useState(localStorage.getItem("__uid"));
  const [copyOpen, setCopyOpen] = useState(false);
  const [copyToChildModalOpen, setCopyToChildModalOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [zeeOpen, setZeeOpen] = useState(false);
  const [trimOpen, setTrimOpen] = useState(false);
  const [videoSpeedOpen, setVideoSpeedOpen] = useState(false);
  const [loder, setLoder] = useState(false);
  const [thumbClip, setThumbClip] = useState({});
  const [selectThumbnail, setSelectThumbnail] = useState("");
  const [publishLoader, setPublishLoader] = useState(false);
  const [autoPopulatedHashtags, setAutoPopulatedHashtags] = useState([]);
  const [modalIsOpenPublishOverlay, setIsOpenPublishOverlay] = useState(false);
  const [publishThumbnails, setPublishThumbnails] = useState([]);
  const [thirdPartyUrl, setThirdPartyUrl] = useState("");
  const [publishToCMS, setPublishTOCMS] = useState(false);
  const [genTitleModalOpen, setGenTitleModalOpen] = useState(false);
  const [titleModalOpen, setTitleModalOpen] = useState(false);
  const [publicStatus, setPublicStatus] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [publishClipId, setPublishedClipId] = useState("");
  const [thumbnailUrls, setThumbnialUrls] = useState([]);
  const [isShowCsv, setIsShowCsv] = useState(false);
  const [illustoData, setIllustoData] = useState([]);
  const [illustomodalOpen, setIllustoModalOpen] = useState(false);
  const [sftpOpen, setSftpOpen] = useState(false);
  const [sftpFolder, setSftpFolder] = useState("watch");
  const [openJsonDetails, setOpenJsonDetails] = useState(false);
  const [captionModal, setCaptionModal] = useState(false);
  const [showMetadataDetailsButton, setShowMetadataDetailsButton] = useState(false);
  const [showMetadataDetailsModal, setShowMetadataDetailsModal] = useState(null);
  const [selectedClip, setSelectedClip] = useState(null);
  const [openPublishThumbnailModal, setOpenPublishThumbnailModal] = useState(false);
  const [publishThumbnailClip, setPublishThumbnailClip] = useState(null);
  const [thumbnails, setThumbnails] = useState([]);
  const illustopopup = () => {
    setIllustoModalOpen(false);
  };
  const exportJson = async (clipId, accessType, highlightType) => {
    let data = {
      clipId: clipId._id,
      accessType,
      highlightType,
      entityId: clipId?.entityId,
      streamId: id,
      aspectRatio: filters?.aspectRatio ? filters?.aspectRatio : clip?.aspectRatio || ASPECT_RATIO["16_9"],
    };
    amplitude.logEvent("export_json_triggered", {
      page: "clip",
      accessType,
      highlightType,
    });
    const { value } = await clipExportJson(data);
    if (value.status) {
      notification["success"]({ message: "JSON Downloaded Successfully" });
      FileDownload(JSON.stringify(value.data), `${clipId._id}.json`);
      amplitude.logEvent("json_exported", {
        page: "clip",
        accessType,
        highlightType,
      });
    } else {
      notification["error"]({ message: "Data not found" });
    }
  };

  const exportEDL = async (clipId) => {
    let data = {
      id: clipId,
    };
    amplitude.logEvent("export_edl_triggered", {
      page: "clip",
      _id: clipId,
    });
    const { value } = await clipExportEDL(data);
    if (value.status) {
      notification["success"]({ message: value.message });
      // Open the link in a new tab with desired features (optional)
      window.open(value.data, "_blank", "noopener,noreferrer");
      amplitude.logEvent("edl_exported", {
        page: "clip",
        _id: clipId,
      });
    } else {
      notification["error"]({ message: value.message });
    }
  };

  useEffect(() => {
    if (filters?.aspectRatio) {
      setThumbnialUrls(
        clip?.editedVideos?.find(
          ({ aspect_ratio, event }) => aspect_ratio === filters?.aspectRatio && event !== EVENT_NAME.DYNAMIC,
        )?.thumbnails || [],
      );
    } else {
      setThumbnialUrls(clip?.videoThumbnailUrls);
    }
  }, [clip?.editedVideos, clip?.videoThumbnailUrls, filters?.aspectRatio]);

  useEffect(() => {
    if (clientSetting?.clientType === ZEE_CLIENT) {
      setThumbnails(publishThumbnailClip?.customThumbnailUrls || []);
    } else {
      setThumbnails(thumbnailUrls);
    }
  }, [clientSetting?.clientType, publishThumbnailClip?.customThumbnailUrls, thumbnailUrls]);
  const exportDataFeedJson = async (clipId, accessType, highlightType) => {
    try {
      const payload = {
        clipId: clipId,
        accessType,
        highlightType,
        entityId: clip?.entityId,
        streamId: id,
        aspectRatio: filters?.aspectRatio || ASPECT_RATIO["16_9"],
      };

      amplitude.logEvent("export_data_feed_json_triggered", {
        page: "clip",
        ...payload,
      });

      const { value } = await clipExportJson(payload);
      if (!value.status) {
        notification.error({ message: "Data not found" });
        return;
      }

      const { streamId, over } = value.data;
      const inningsId = value.data?.period || value.data?.inningsId;

      if (!streamId || !inningsId || !over) {
        notification.error({ message: "Can not export as missing over and innings details" });
        return;
      }

      const response = await getDataFeedStatsPerformMetadata({
        inningsId,
        over,
        streamId,
      });

      if (response?.error || !response?.payload?.data) {
        notification.error({ message: response?.error?.message || "Data not found" });
        return;
      }

      const data = response?.payload?.data;

      const fileName = `${streamId}_${inningsId}_${over}.json`;
      FileDownload(JSON.stringify(data, null, 2), fileName);

      amplitude.logEvent("data_feed_json_exported", {
        page: "clip",
        accessType,
        highlightType,
      });
    } catch (error) {
      notification.error({ message: "Something went wrong" });
      console.error("error trying to export datafeed json", error);
    }
  };

  const showMetadataDetails = async () => {
    amplitude.logEvent("show_metadata_details_triggered", {
      page: "clip",
    });

    if (!clip?.videoUrl) {
      console.error("No video url for the clip found");
      notification.error({ message: "No video url for the clip found" });
      setShowMetadataDetailsModal(null);
      return;
    }
    const response = await fetchClipMetadata({ videoUrl: clip.videoUrl });
    if (!response?.success || !response?.data) {
      notification.error({ message: "No metadata found for the clip" });
      setShowMetadataDetailsModal(null);
      return;
    }

    setShowMetadataDetailsModal(response?.data);
  };
  //DownLoad the Clip

  const handleDownloadSuccess = useCallback(
    (entityId, streamId) => {
      getDownloadVideoStatus({ entityId, streamId });
      amplitude.logEvent("clip_downloaded", { page: "clip" });
    },
    [getDownloadVideoStatus],
  );

  const handleDownloadError = useCallback((value) => {
    const message = value?.data?.message || value?.error?.message || "Something went wrong";

    if (value?.data?.limitError) {
      setIsAlertOpen(true);
      setAlertMessage(message);
    } else {
      notification["error"]({ message });
    }
  }, []);

  const downloadWithPresignedUrl = useCallback(
    async (clip, url) => {
      try {
        const isProcessingLimit = clientSetting?.permissions?.isProcessingLimit;
        const isWorkspace = entityType === ENTITY_TYPE.WORKSPACES;
        const isProcessingWorkspace = isProcessingLimit && isWorkspace;

        const payloadData = isProcessingWorkspace
          ? {
              url,
              streamId: streamDetails.streamId,
              duration: clip.duration,
              entityId: clip?.entityId,
              contentId: clip._id,
              contentType: "clip",
              userId,
              title: clip.episodeTitle || "",
            }
          : {
              url,
              streamId: streamDetails.streamId,
              entityId,
            };

        const payload = isProcessingWorkspace
          ? await getDownloadVideo(payloadData)
          : await getCloudPreSignedURL(payloadData);

        const { value } = payload;
        if (value?.data?.url) {
          createPresignedDownloadLink(value?.data?.url);
          if (isProcessingWorkspace) {
            handleDownloadSuccess(clip?.entityId, streamDetails.streamId);
          }
        } else {
          throw value;
        }
      } catch (error) {
        console.error("Download error:", error);
        throw error;
      }
    },
    [
      clientSetting?.permissions?.isProcessingLimit,
      entityType,
      streamDetails?.streamId,
      userId,
      entityId,
      getDownloadVideo,
      getCloudPreSignedURL,
      handleDownloadSuccess,
    ],
  );

  const downloadClip = useCallback(
    async (clip) => {
      if (!streamDetails?.streamId) {
        notification["error"]({ message: "Stream details are missing" });
        return;
      }

      amplitude.logEvent("download_clip_triggered", { page: "clip" });

      const url =
        clip.editedVideos?.find((o) => o?.aspect_ratio === filters?.aspectRatio && o.event !== "dynamicCropped")
          ?.video_url || clip?.videoUrl;

      try {
        if (clientSetting?.permissions?.allowDirectDownload) {
          createDownloadLink(url);
        } else {
          await downloadWithPresignedUrl(clip, url);
        }
      } catch (error) {
        console.error("Download error:", error);
        handleDownloadError(error);
      }
    },
    [
      streamDetails?.streamId,
      filters?.aspectRatio,
      clientSetting?.permissions?.allowDirectDownload,
      downloadWithPresignedUrl,
      handleDownloadError,
    ],
  );

  const downloadMxf = async (clip) => {
    amplitude.logEvent("download_mfx_clip_triggered", {
      page: "clip",
    });
    const link = document.createElement("a");
    link.href = clip?.mxfUrl;
    document.body.appendChild(link);
    link.click();
    amplitude.logEvent("mfx_clip_downloaded", {
      page: "clip",
    });
  };

  const zeeArchiveDownload = async (clip) => {
    notification["success"]({ message: "Process initiated..." });
    try {
      const value = await downloadClipZipPackage({
        id: clip._id,
      });
      if (value.value.status) {
        const link = document.createElement("a");
        link.href = value.value.data;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        notification["error"]({ message: value.message });
      }
    } catch (error) {
      console.error("Error:", error);
      notification["error"]({ message: "An error occurred while downloading the archive" });
    }
  };

  const downloadFile = async (clip) => {
    amplitude.logEvent("download_edl_triggered", {
      page: "clip",
    });
    const url = clip.csvData.edlFilePath;
    if (url) {
      const filename = url.split("/")[url.split("/").length - 1];
      const { data } = await axios.get(url);
      var element = document.createElement("a");
      element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(data));
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();
      amplitude.logEvent("edl_downloaded", {
        page: "clip",
      });

      document.body.removeChild(element);
    }
  };

  const delOpen = (id) => {
    setUserId(id);
    setDeleteModalOpen(true);
    amplitude.logEvent("delete_clip_modal_triggered", {
      page: "clip",
    });
  };

  const openCopyFun = () => {
    setCopyOpen(true);
    amplitude.logEvent("copy_clip_modal_triggered", {
      page: "clip",
    });
  };
  const openS3Publish = () => {
    const ratios = filters?.aspectRatio || clip?.aspectRatio;
    if (
      clip?.duration &&
      clientSetting?.permissions?.isUploadToCloudDuration &&
      clip?.duration < clientSetting?.limitation?.maxUploadToCloudClipDuration &&
      ratios === ASPECT_RATIO["16_9"]
    ) {
      notification["error"]({
        message: `User can't publish the clip under ${clientSetting?.limitation?.maxUploadToCloudClipDuration} seconds. (16:9)`,
      });
      return;
    } else {
      setS3Open(true);
      amplitude.logEvent("upload_cloud_modal_triggered", {
        page: "clip",
      });
    }
  };
  const openFTPPublish = () => {
    setFTPOpen(true);
    amplitude.logEvent("ftp_publish_modal_triggered", {
      page: "clip",
    });
  };
  const openPublishCMS = () => {
    setPublishTOCMS(true);
    amplitude.logEvent("publish_cms_modal_triggered", {
      page: "clip",
    });
  };

  const openUploadToBrightCove = async () => {
    setLoder(true);
    amplitude.logEvent("upload_brightCove_modal_triggered", {
      page: "clip",
    });

    const clipUrl = clip.videoUrl;
    const streamTitle = streamDetails?.title;
    let organization = organizations.find((element) => element?.organizationId === clip?.entityId);
    const payload = {
      client_id: organization?.client_id,
      client_secret: organization?.client_secret,
      account_id: organization?.account_id,
      entityId: clip?.entityId,
    };

    const data = await fetchBrightCoveToken(payload);
    if (data.value.data.error) {
      notification["error"]({ message: "Invalid Credentials" });
      return;
    }
    const accessToken = data.action.payload.data.access_token;
    await getPublicUrl(clipUrl, streamTitle, accessToken, organization?.account_id);
    amplitude.logEvent("brightCove_uploaded", {
      page: "clip",
    });
    setLoder(false);
  };

  // Fetch the public Url
  const getPublicUrl = async (url, streamTitle, accessToken, accountId) => {
    const data = await getPublicUrls({ url });

    if (data.value.status) {
      const publicUrl = data.value.data.location;
      const token = accessToken;
      const payload = {
        publicUrl,
        streamTitle,
        token,
        accountId,
        _id: clip?._id,
        streamId: clip?.streamId,
      };
      const resp = await uploadClipInBrightCove(payload);

      if (resp.value.status) {
        setLoder(false);
        notification["success"]({ message: resp.value.message });
      } else {
        notification["error"]({ message: resp.value.message });
      }
    } else {
      notification.open({ message: "something went wrong" });
    }
  };

  //Copy the Clip using Stream ID
  const copyClipFun = async (payload) => {
    amplitude.logEvent("copy_clip_triggered", {
      page: "clip",
      type: "single",
    });
    setLoder(true);
    const data = await copyClip(payload);
    if (data.value.success) {
      notification["success"]({ message: data.value.message });
      allClips();

      amplitude.logEvent("copy_clip_succeeded", {
        page: "clip",
        type: "single",
      });
    } else {
      notification["error"]({ message: data.value.message });

      amplitude.logEvent("copy_clip_failed", {
        page: "clip",
        type: "single",
        error: data.value.message,
      });
    }
    setLoder(false);
  };

  //Trim the Clip
  const trimClip = async (payload) => {
    setLoder(true);
    const data = await getTrimClip(payload);
    if (data.value.status) {
      notification["success"]({ message: data.value.message });
    } else {
      notification["error"]({ message: data.value.message });
    }
    setLoder(false);
  };

  //Edit the Clip
  const editClips = async (payload) => {
    setLoder(true);
    const data = await editClip(payload);
    if (data.value.success) {
      notification["success"]({ message: data.value.message });
      await allClips();
    } else {
      notification["error"]({ message: data.value.message });
    }
    setLoder(false);
  };

  //Edit the Clip for CMS
  const editClipsForCms = async (payload) => {
    setLoder(true);
    const data = await editClip(payload);
    if (data.value.success) {
      notification["success"]({ message: data.value.message });
      await allClipsForCms();
    } else {
      notification["error"]({ message: data.value.message });
    }
    setLoder(false);
  };

  //Publish the Clip
  const publishClips = async (payload) => {
    setLoder(true);
    const data = await publishClip(payload);
    if (data.value.status === true) {
      notification["success"]({ message: data.value.message });
      await allClips();
    } else if (data.value.status === false) {
      notification["error"]({ message: data.value.message });
    } else if (data.value.status === 101) {
      notification["warning"]({ message: data.value.message });
    }
    setLoder(false);
  };
  const delThumbOpen = (clip) => {
    amplitude.logEvent("change_thumbnail_modal_triggered", {
      page: "clip",
    });
    setThumbClip(clip);
    setThumbModalOpen(true);
  };
  const addThumbNAil = async () => {
    let payload = {
      videoThumbnailUrl: selectThumbnail,
      id: thumbClip.id,
    };
    if (filters?.aspectRatio) {
      payload.aspectRatio = filters?.aspectRatio || clip?.aspectRatio;
    }
    const data = await editClip(payload);
    amplitude.logEvent("thumbnail_changed", {
      page: "clip",
    });
    notification["success"]({ message: data.value.message });
    if (data.value.success) {
      await allClips();
    }
  };

  //Add New thumbnail on clip
  const handleSubmit = (e) => {
    e.preventDefault();
    addThumbNAil();
  };

  useEffect(() => {
    if (filters?.aspectRatio) {
      setSelectThumbnail(
        clip?.editedVideos?.find(
          ({ aspect_ratio, event }) => aspect_ratio === filters?.aspectRatio && event !== EVENT_NAME.DYNAMIC,
        )?.thumbnailUrl,
      );
    } else {
      setSelectThumbnail(clip.videoThumbnailUrl);
    }
  }, [filters]);

  const deleteGridClip = async () => {
    amplitude.logEvent("delete_clips_triggered", {
      page: "clip",
      type: "single",
    });
    const clipId = clip._id;
    setLoder(true);
    const { value } = await deleteClips({ id: clipId });
    if (value.success) {
      notification["success"]({ message: value.message });
      allClips();
      amplitude.logEvent("delete_clips_succeeded", {
        page: "clip",
        type: "single",
      });
    }
    const filteredClips = folderArray.filter((item) => item?._id !== clipId);
    setFolderArray(filteredClips);
    delclose();
    setLoder(false);
  };

  const delclose = () => {
    setDeleteModalOpen(false);
  };

  // Export XMP File
  const exportXMPFile = async (id) => {
    amplitude.logEvent("export_xmp_triggered", {
      page: "clip",
    });
    const { value } = await clipExportXml({
      id: clip._id,
      aspectRatio: filters?.aspectRatio || ASPECT_RATIO["16_9"],
      entityId: clip?.entityId,
    });
    if (value.status) {
      notification["success"]({ message: "XML File Downloaded Successfully" });
      amplitude.logEvent("xmp_exported", {
        page: "clip",
      });
      window.open(value.data, "_blank");
    } else {
      notification["error"]({ message: "Data not found" });
    }
  };
  //Upload to sftp
  const publishToSFTP = async () => {
    amplitude.logEvent("sftp_publish_triggered", {
      page: "clip",
    });
    setSftpOpen(false);
    if (filters?.aspectRatio === ASPECT_RATIO["9_18"]) {
      const isAspectRatioPresent = SUPPORTED_ASPECTRATIO_FOR_SHOT_UPLOAD.every((supportedRatio) =>
        clip?.editedVideos?.some(
          ({ aspect_ratio, event, status }) =>
            aspect_ratio === supportedRatio && event !== EVENT_NAME.DYNAMIC && status !== SYNCING_STATUS.PROCESSING,
        ),
      );
      if (!isAspectRatioPresent) {
        notification.error({ message: "Please generate 9:16 and 3:4 ratios clips to upload clip in 9:18" });
        return;
      }
    }
    notification["success"]({ message: "Process Initiated..." });
    const clipId = clip._id;
    const isMedia = sftpFolder === "watch" ? true : false;
    const value = await updatesftp({
      id: clipId,
      clipsAspectRatio: filters?.aspectRatio || clip.aspectRatio,
      isMedia,
      entityId: clip?.entityId,
    });
    if (value?.value?.status) {
      notification["success"]({ message: value?.value?.message });
      amplitude.logEvent("sftp_published", {
        page: "clip",
      });
    } else {
      notification["error"]({ message: value?.value?.message });
      amplitude.logEvent("sftp_publish_failed", {
        page: "clip",
        error: value?.value?.message,
      });
    }
  };

  //share on social media
  const shareOnSocialMedia = async (clip) => {
    amplitude.logEvent("share_modal_triggered", {
      page: "clip",
    });
    const customThumbs =
      clip?.generatedThumbnailUrls.find((data) => data?.aspectRatio === (aspectRatio || ASPECT_RATIO["16_9"]))
        ?.thumbnails || [];
    setPublishThumbnails([...clip?.videoThumbnailUrls, ...customThumbs] || []);
    setIsOpenPublishOverlay(true);
    setPublishedClipId(clip);

    const editedVideoUrl = clip?.editedVideos?.find(
      (o) => o?.aspect_ratio === aspectRatio && o.event !== "dynamicCropped",
    )?.video_url;

    const shareUrl = editedVideoUrl || clip?.videoUrl;

    const { value } = await getCloudPreSignedURL({
      url: shareUrl,
      streamId: streamDetails?.streamId,
      entityId,
    });

    const thirdPartyUrl = value?.data?.url || null;
    setPublicStatus(!!thirdPartyUrl);
    setThirdPartyUrl(thirdPartyUrl);
  };

  const downloadMp4 = () => {
    const link = document.createElement("a");
    link.href = clip.mp4VideoUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const updateClipDetail = async () => {
    amplitude.logEvent("rollback_clip_triggered", {
      page: "clip",
    });

    let payload = {
      id: clip?._id,
      editClipFilterObject: {
        ...clip?.editClipFilterObject,
        isAddedToClipsPage: !clip?.editClipFilterObject?.isAddedToClipsPage,
        isRollbacked: true,
      },
    };
    const { value } = await updateClipDetails(payload);
    if (value.success) {
      allClips();
      getStreamDetail({ id, entityId: clip?.entityId });

      notification.success({ message: "Clip rollbacked successfully!" });
      amplitude.logEvent("clip_rolled_back", {
        page: "clip",
      });
    } else {
      notification.error({ message: "Somthing went wrong!" });
    }
  };

  const deleteHlsToMp4 = async (clip) => {
    const { deleteHlsToMp4 } = props;
    const { value } = await deleteHlsToMp4({ streamId: clip?.streamId });
    if (value?.status) {
      notification.success({ message: value?.message });
      refreshClips();
      handleSteps(1);
    }
  };

  const uploadOnCloud = async () => {
    setLoder(true);
    amplitude.logEvent("upload_cloud_triggered", {
      page: "clip",
    });
    notification.success({ message: "Process Initiated" });
    let videoUrl =
      clip?.editedVideos?.find(
        ({ aspect_ratio, event, status }) =>
          aspect_ratio === filters?.aspectRatio &&
          status === SYNCING_STATUS.COMPLETED &&
          (event === "autoFlip" || event === "croppedVideos"),
      )?.video_url || clip.videoUrl;
    const data = await s3BucketPublish({
      bucket: {},
      streamId: clip?.streamId,
      fileUrl: videoUrl,
      clipId: clip._id,
    });
    if (data.value.success || data.value.status) {
      amplitude.logEvent("cloud_uploaded", {
        page: "clip",
      });
      notification["success"]({ message: data.value.message });
    } else {
      notification["error"]({ message: data.value.message });
    }
    refreshClips();
    setLoder(false);
  };

  const advanceEditor = async () => {
    amplitude.logEvent("advanced_editor_triggered", {
      page: "clip",
    });
    let videoUrl =
      clip?.editedVideos?.find(
        ({ aspect_ratio, event }) =>
          aspect_ratio === filters?.aspectRatio && (event === "autoFlip" || event === "croppedVideos"),
      )?.video_url || clip.videoUrl;
    let videoThumbnailUrl =
      clip?.editedVideos?.find(
        ({ aspect_ratio, event }) =>
          aspect_ratio === filters?.aspectRatio && (event === "autoFlip" || event === "croppedVideos"),
      )?.thumbnailUrl || clip.videoThumbnailUrl;
    if (aspectRatioCheckForIllusto(filters?.aspectRatio ? filters?.aspectRatio : clip?.aspectRatio)) {
      notification["error"]({ message: "Currently, 4:5 aspect ratio is not supported in the Studio Editor" });
      return;
    }
    let newClipInserted = {};
    if (_.includes([null, "", undefined, "undefined"], clip?.projectId)) {
      newClipInserted = await genrateNewClip({
        aspectRatio: filters?.aspectRatio ? filters?.aspectRatio : clip?.aspectRatio,
        title: clip?.episodeTitle,
        streamId: clip?.streamId,
        properties: clip?.properties,
        entityId: clip?.entityId,
        videoUrl: videoUrl,
        videoThumbnailUrl: videoThumbnailUrl,
        videoThumbnailUrls: clip?.videoThumbnailUrls,
        isClipCreateByIllusto: true,
        cliplistIdArr: clip?.cliplistIdArr,
        clipRating: clip?.clipRating,
        highlightId: [],
        start_time: clip?.start_time ? clip?.start_time : "",
        end_time: clip?.end_time ? clip?.end_time : "",
        previewData: {
          previewUrl: clip?.editedPreviewUrl ? clip?.editedPreviewUrl : clip?.videoUrl,
          totalDurationWithoutBumper: clip?.totalDurationWithoutBumper,
          thumbnail: videoThumbnailUrl,
          thumbnails: clip?.videoThumbnailUrls,
          duration: clip?.duration,
          customData: clip?.customData,
          clipData: clip?.clipData,
          type: "clip",
        },
      });
    }
    const data = await advanceEditorIllusto({
      entityId: clip?.entityId,
      clipObjId: get(newClipInserted, "value.data.clipId", "")
        ? get(newClipInserted, "value.data.clipId", "")
        : clip?._id,
      clipDetails: clip,
      userId: userId,
      type: "clip",
      projectId: clip?.projectId,
      videoUrl: videoUrl,
      aspectRatio: filters?.aspectRatio ? filters?.aspectRatio : clip?.aspectRatio,
    });
    if (get(data, "value.status", false) && get(data, "value.data.code", -1) === 0) {
      notification["success"]({ message: data.value.message });
      window.open(get(data, "value.data.data.redirectUrl", ""), "_blank", "noreferrer");
    } else if (!get(data, "value.status", true)) {
      notification["error"]({ message: data.value.message });
      amplitude.logEvent("advanced_editor_redirect_failed", {
        page: "clip-editor",
        error: data.value.message,
      });
    } else if (get(data, "value.data.code", 0) === -1) {
      notification["error"]({ message: data.value.message });
      amplitude.logEvent("advanced_editor_redirect_failed", {
        page: "clip-editor",
        error: data.value.message,
      });
    }
  };

  useEffect(() => {
    setShowMetadataDetailsButton(streamDetails?.isMediaLive);
  }, [streamDetails?.isMediaLive]);

  const isUploadEnabled = (clip) => {
    const hasOutcome = clip?.clipData?.outcome;
    if (clientSetting?.permissions?.disablePublishWithoutTags && !hasOutcome) {
      return false;
    }
    return true;
  };

  const handlePublishThumbnailModal = (clip) => {
    if (clip) {
      setPublishThumbnailClip(clip);
    } else {
      setPublishThumbnailClip(null);
    }
    if (openPublishThumbnailModal) {
      // on closing of thumbnail modal, fetch clips
      refreshClips();
    }
    setOpenPublishThumbnailModal(!openPublishThumbnailModal);
  };

  const shouldRegenrateThumbnail = (clip) => {
    // Check if it's a ZEE_CLIENT and if the thumbnail status is FAILED
    return (
      selectedEntity?.name === ZEE_CLIENT && clip?.customThumbnailStatus === STREAM_STATUS_MAP[STREAM_STATUS?.FAILED]
    );
  };

  const showViewThumbnailOption = (clip) => {
    // Check if the aspect ratio is 16_9 for ZEE_CLIENT
    return (
      clientSetting?.permissions?.viewThumbnail ||
      (clip?.aspectRatio === ASPECT_RATIO["16_9"] && clientSetting?.clientType === ZEE_CLIENT)
    );
  };

  const actions = {
    advanceEditor: true,
    cropper: true,
    copyClip: true,
    exportDataFeedJSON: true,
    showMetadataDetails: true,
    change_thumbnail: true,
    copyToChild: true,
    downloadVideo: true,
    downloadEDL: true,
    exportEdl: true,
    isPackageDownload: true,
    edit_publish: true,
    exportJSON: true,
    generateTitle: true,
    publishToCMS: true,
    socialMediaPublish: true,
    show_title: true,
    uploadToCloud: true,
    uploadToFTP: true,
    uploadToSFTP: true,
    uploadToBrightCove: true,
    exportXMP: true,
    rollback: true,
    show_csv: true,
    webisodeScenceCombination: true,
    publish_thumbnail: true,
    deleteClip: true,
    generateCaption: true,
  };
  const downloadActions = {
    download_video: true,
    delete_video: true,
  };

  const handleRegenrateThumbnail = async (clip) => {
    const { value } = await regenerateThumbnail({
      clipId: clip?._id,
      videoUrl: clip?.videoUrl,
      streamId: clip?.streamId,
    });
    if (value?.success) {
      notification["success"]({ message: "process initiated..." });
    }
  };
  const handleClipsTableAction = (profileFeature, menuItems) => {
    for (const key in actions) {
      if (profileFeature.hasOwnProperty(key) && profileFeature?.[key]) {
        switch (key) {
          case "advanceEditor":
            clientSetting?.permissions?.advanceEditor &&
              currentRole !== ROLE.REVIEWER &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      advanceEditor(clip?.id, clip?.streamId);
                    }}
                  >
                    <img src={IllustoAdvEditorLogo} alt="illustologo" />
                    <span>&nbsp; Advanced Editor</span>
                  </a>
                ),
                key: "19",
              });
            break;
          case "copyClip":
            clientSetting?.permissions?.isCopyClip &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      openCopyFun();
                    }}
                  >
                    <CopyOutlined />
                    <span>Copy</span>
                  </a>
                ),
                key: "1",
              });
            break;
          case "change_thumbnail":
            clip?.videoThumbnailUrls?.length !== 1 &&
              clientSetting?.permissions?.isChangeClipsThumbnail &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      delThumbOpen(clip);
                    }}
                  >
                    <PictureOutlined />
                    <span>Change Thumbnail</span>
                  </a>
                ),
                key: "3",
              });
            break;

          case "publish_thumbnail":
            if (shouldRegenrateThumbnail(clip)) {
              menuItems.push({
                label: (
                  <a onClick={() => handleRegenrateThumbnail(clip)}>
                    <PictureOutlined />
                    <span>Re-Generate Thumbnail</span>
                  </a>
                ),
                key: "3",
              });
            } else if (showViewThumbnailOption(clip)) {
              menuItems.push({
                label: (
                  <a onClick={() => handlePublishThumbnailModal(clip)}>
                    <PictureOutlined />
                    <span>View Thumbnail</span>
                  </a>
                ),
                key: "3",
              });
            }

            break;

          case "cropper":
            (clientSetting?.permissions?.isStaticCropper || clientSetting?.permissions?.isDynamicCropper) &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      navigate(`/cropper/${clip?._id}`);
                    }}
                  >
                    <AreaChartOutlined />
                    <span>Auto flip{clientSetting?.permissions?.isDynamicCropper ? "/Dynamic flip" : null}</span>
                  </a>
                ),
                key: "2",
              });
            break;
          case "edit_publish":
            clientSetting?.permissions?.zeepublishing &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      setZeeOpen(true);
                      amplitude.logEvent("edit_publish_modal_triggered", {
                        page: "clip",
                      });
                    }}
                  >
                    <CloudUploadOutlined />
                    <span>Edit & Publish</span>
                  </a>
                ),
                key: "zeePublishing",
              });
            break;
          case "isPackageDownload":
            clientSetting?.permissions?.isPackageDownload &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      zeeArchiveDownload(clip);
                    }}
                  >
                    <DownloadOutlined />
                    <span>Archive Download</span>
                  </a>
                ),
                key: "isPackageDownload",
              });
            break;
          case "uploadToCloud":
            clientSetting?.permissions?.isUploadToCloud &&
              isUploadEnabled(clip) &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      clientSetting?.clientType === ZEE_CLIENT ? uploadOnCloud() : openS3Publish();
                    }}
                  >
                    <CloudUploadOutlined />
                    {loder && <Spin indicator={antIcon}></Spin>}
                    <span>Upload To Cloud</span>
                  </a>
                ),
                disabled: loder,
                key: "5",
              });
            break;
          case "uploadToFTP":
            clientSetting?.permissions?.uploadToFTP &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      openFTPPublish();
                    }}
                  >
                    <CloudUploadOutlined />
                    <span>Upload To FTP</span>
                  </a>
                ),
                key: "13",
              });
            break;
          case "uploadToSFTP":
            clientSetting?.permissions?.uploadToSFTP &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      amplitude.logEvent("sftp_upload_modal_triggered", {
                        page: "clip",
                      });
                      setSftpOpen(true);
                    }}
                  >
                    <CloudUploadOutlined />
                    <span>Upload To SFTP</span>
                  </a>
                ),
                key: "14",
              });
            break;

          case "uploadToBrightCove":
            clientSetting?.permissions?.uploadtoBrightcove &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      openUploadToBrightCove();
                    }}
                  >
                    <UploadOutlined />
                    <span>Upload To BrightCove</span>
                  </a>
                ),
                key: "9",
              });
            break;

          case "downloadVideo":
            clientSetting?.permissions?.downloadClipButton &&
              !noDownloadStreams.includes(clip?.streamId) &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      downloadClip(clip);
                    }}
                  >
                    <DownloadOutlined />
                    <span>Download Video</span>
                  </a>
                ),
                key: "8",
              });
            clip?.mxfUrl &&
              menuItems.push({
                label: (
                  <a onClick={() => downloadMxf(clip)}>
                    <DownloadOutlined />
                    <span>Download MXF</span>
                  </a>
                ),
                key: "19",
              });
            break;

          case "showMetadataDetails":
            showMetadataDetailsButton &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      showMetadataDetails();
                    }}
                  >
                    <InfoCircleOutlined />
                    <span>Metadata Details</span>
                  </a>
                ),
                key: "showMetadataDetails",
              });
            break;
          case "generateTitle":
            clientSetting?.permissions?.isGenerateClipTitle &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      amplitude.logEvent("generate_title_modal_triggered", {
                        page: "clip",
                      });
                      setGenTitleModalOpen(!genTitleModalOpen);
                    }}
                  >
                    <EditOutlined />
                    <span>Generate Title</span>
                  </a>
                ),
                key: "generateTitle",
              });
            break;
          case "deleteClip":
            clientSetting?.permissions?.isClipDelete &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      delOpen(clip?.id);
                    }}
                  >
                    <DeleteOutlined />
                    <span>Delete</span>
                  </a>
                ),
                key: "7",
              });
            break;
          case "exportJSON":
            {
              if (clientSetting?.permissions?.exportClipJSON) {
                if (clip.isHighlightVideo) {
                  menuItems.push({
                    label: (
                      <a>
                        {" "}
                        <ExportOutlined />
                        <span>Export JSON</span>
                      </a>
                    ),
                    children: [
                      {
                        label: (
                          <a
                            onClick={() => {
                              exportJson(clip, "highlight", "highlightClip");
                            }}
                          >
                            <span>Export HL JSON</span>
                          </a>
                        ),
                        key: "JSON1",
                      },
                      {
                        label: (
                          <a
                            onClick={() => {
                              exportJson(clip, "highlight", "onlyClip");
                            }}
                          >
                            <span>Export Clip JSON</span>
                          </a>
                        ),
                        key: "JSON2",
                      },
                    ],
                  });
                } else {
                  menuItems.push({
                    label: (
                      <a
                        onClick={() => {
                          exportJson(clip, "clip", "");
                        }}
                      >
                        <ExportOutlined />
                        <span>Export Clip JSON</span>
                      </a>
                    ),
                    key: "15",
                  });
                  if (clientSetting?.permissions?.exportDataFeedJSON) {
                    menuItems.push({
                      label: (
                        <a
                          onClick={() => {
                            exportDataFeedJson(clip?._id, "clip", "");
                          }}
                        >
                          <ExportOutlined />
                          <span>Export Data Feed JSON</span>
                        </a>
                      ),
                      key: "exportDataFeedJSON",
                    });
                  }
                }
              }
            }
            break;
          case "exportEdl":
            if (clientSetting?.permissions?.exportEdl && [1, 2, 3].indexOf(step) !== -1) {
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      exportEDL(clip?._id);
                    }}
                  >
                    <ExportOutlined />
                    <span>Export {`${step === 2 ? "HL" : ""}`} EDL</span>
                  </a>
                ),
                key: "exportEdl",
              });
            }
            break;
          case "socialMediaPublish":
            clientSetting?.permissions?.socialMediaPublish &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      shareOnSocialMedia(clip);
                    }}
                  >
                    <ShareAltOutlined />
                    <span>
                      Social Media Publish
                      {publishLoader && (
                        <Spin
                          size="large"
                          indicator={<LoadingOutlined style={{ fontSize: 18, color: "#000" }} spin />}
                          className="inline-btn-loder"
                        ></Spin>
                      )}
                    </span>
                  </a>
                ),
                key: "12",
              });
            break;
          case "publishToCMS":
            clientSetting?.permissions?.publishToCMS &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      openPublishCMS();
                      setSelectedClip(clip);
                    }}
                  >
                    <SettingOutlined />
                    <span>Publish to CMS</span>
                  </a>
                ),
                key: "6",
              });
            break;
          case "download_edl":
            clientSetting?.permissions?.zeepublishing &&
              clip?.csvData?.edlFilePath &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      downloadFile(clip);
                    }}
                  >
                    <DownloadOutlined />
                    <span>Download EDL</span>
                  </a>
                ),
                key: "downloadEDL",
              });
            break;
          case "show_title":
            // Object.keys(clip?.aiTitle || {}).length > 0 &&
            clientSetting?.permissions?.isGenerateClipTitle &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      setTitleModalOpen(!titleModalOpen);
                      amplitude.logEvent("generate_title_modal_triggered", {
                        page: "clip",
                      });
                    }}
                  >
                    <FormOutlined />
                    <span>Show Title</span>
                  </a>
                ),
                key: "showTitle",
              });
            break;
          case "exportXMP":
            clientSetting?.permissions?.exportXMP &&
              menuItems.push({
                label: (
                  <a onClick={() => exportXMPFile(clip._id)}>
                    <ExportOutlined />
                    <span>Export XML file</span>
                  </a>
                ),
                key: "exportXMP",
              });
            break;
          case "rollback":
            clientSetting?.permissions?.allowEnhancedTagging &&
              clip?.editClipFilterObject?.isAddedToClipsPage &&
              menuItems.push({
                label: (
                  <a onClick={() => updateClipDetail(clip)}>
                    <RollbackOutlined />
                    <span>Rollback</span>
                  </a>
                ),
                key: "isAddedToClipsPage",
              });
            break;
          case "show_csv":
            clientSetting?.clientType === ZEE_CLIENT &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      amplitude.logEvent("show_csv_triggered", {
                        page: "clip",
                      });
                      setIsShowCsv(true);
                    }}
                  >
                    <FormOutlined />
                    <span>Show CSV</span>
                  </a>
                ),
                key: "show_csv",
              });
            break;
          case "webisodeScenceCombination":
            clientSetting?.clientType === ZEE_CLIENT &&
              streamDetails?.fields?.categoryType === ZEE_CATEGORY_TYPES.WEBISODE &&
              currentRole === ROLE.ADMIN &&
              Object.keys(clip?.webisodeSceneDetails || {}).length !== 0 &&
              menuItems.push({
                label: (
                  <a onClick={() => setOpenJsonDetails(true)}>
                    <EyeOutlined />
                    <span>View Webisode Scene Combinations</span>
                  </a>
                ),
                key: "webisodeScenceCombination",
              });
            break;
          case "generateCaption":
            (clip?.audioTranscript_api || (clip?.type === "highlight" && clip?.enableCaptionGeneration)) &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      amplitude.logEvent("generateCaption", {
                        page: "clip",
                      });
                      setCaptionModal(true);
                    }}
                  >
                    <RollbackOutlined />
                    <span>Generate Caption</span>
                  </a>
                ),
                key: "generateCaption",
              });
          default:
            break;
        }
      }
    }
  };

  const handleDownloadTableAction = (profileFeature, menuItems) => {
    for (const key in downloadActions) {
      if (profileFeature.hasOwnProperty(key) && profileFeature?.[key]) {
        switch (key) {
          case "download_video":
            clientSetting?.permissions?.isHlsToMp4 &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      downloadMp4();
                    }}
                  >
                    <DownloadOutlined />
                    <span>Download Video</span>
                  </a>
                ),
                disabled: !clip?.mp4VideoUrl || noDownloadStreams.includes(clip?.streamId),
                key: "1",
              });
            break;
          case "delete_video":
            clientSetting?.permissions?.isHlsToMp4 &&
              menuItems.push({
                label: (
                  <a
                    onClick={() => {
                      deleteHlsToMp4(clip);
                    }}
                  >
                    <DeleteOutlined />
                    <span>Delete</span>
                  </a>
                ),
                key: "2",
              });
            break;
          default:
            break;
        }
      }
    }
  };

  const CommonJsonContextValues = {
    openJsonDetails,
    setOpenJsonDetails,
    jsonData: clip?.webisodeSceneDetails || {},
    modalHeader: "Webisode scene combinations",
  };
  return (
    <>
      <div className="dropdown-btns">
        <AccessControl
          code="menuItem"
          page="clips"
          handleTableAction={step !== 4 ? handleClipsTableAction : handleDownloadTableAction}
        />
      </div>
      <Modal
        isOpen={sftpOpen}
        ariaHideApp={false}
        onRequestClose={() => {
          setSftpOpen(false);
        }}
        contentLabel="Upload To SFTP Folder"
        portalClassName="react-modal"
        overlayClassName="modal"
        shouldCloseOnOverlayClick={false}
        className="modal-dialog react-modal-dialog-sm modal-dialog-centered filter-modal custom-small-modal"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Upload To SFTP Folder</h5>
          </div>
          <div className="react-modal-body text-center">
            <Radio.Group
              name="radiogroup"
              defaultValue={""}
              onChange={(e) => {
                setSftpFolder(e.target.value);
              }}
              value={sftpFolder}
            >
              {["aux", "watch"].map((item) => {
                return (
                  <Radio key={item} value={item}>
                    {item.toUpperCase()}
                  </Radio>
                );
              })}
            </Radio.Group>
          </div>
          <div className="react-modal-footer text-center">
            <div className="react-foo-container">
              <button
                type="button"
                onClick={() => {
                  setSftpOpen(false);
                }}
                className="btn btn-white"
              >
                Close{" "}
              </button>
              <button
                type="button"
                onClick={() => {
                  publishToSFTP();
                }}
                className="btn btn-primary"
              >
                Upload
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={illustomodalOpen}
        ariaHideApp={false}
        onRequestClose={illustopopup}
        contentLabel="Delete Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        shouldCloseOnOverlayClick={false}
        className="modal-dialog react-modal-dialog-sm modal-dialog-centered filter-modal custom-small-modal"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Illusto Editor URL</h5>
          </div>
          <div className="react-modal-body text-center">
            Redirect to Editor{" "}
            <a href={illustoData} target="_blank" rel="noreferrer">
              Click here{" "}
            </a>
          </div>
          <div className="react-modal-footer text-center">
            <div className="react-foo-container">
              <button type="button" onClick={illustopopup} className="btn-s-one fill">
                Close{" "}
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <CommonJsonContext.Provider value={CommonJsonContextValues}>
        <CommonJsonDetails />
      </CommonJsonContext.Provider>
      <ChangeThumbNail
        clip={clip}
        selectThumbnail={selectThumbnail}
        setSelectThumbnail={setSelectThumbnail}
        thumbnailUrls={thumbnailUrls}
        setThumbnialUrls={setThumbnialUrls}
        thumbModelOpen={thumbModelOpen}
        handleSubmit={handleSubmit}
        setThumbModalOpen={setThumbModalOpen}
        addThumbnail={addThumbnail}
        getUploadPicture={getUploadPicture}
        updateClipDetails={updateClipDetails}
        filters={filters}
      />
      {modalIsOpenPublishOverlay ? (
        <ModalPublish
          setIsOpenPublishOverlay={setIsOpenPublishOverlay}
          modalIsOpenPublishOverlay={modalIsOpenPublishOverlay}
          shareOnSocialMedias={shareOnSocialMedias}
          publishThumbnails={publishThumbnails}
          autoPopulatedHashtags={autoPopulatedHashtags}
          setAutoPopulatedHashtags={setAutoPopulatedHashtags}
          selectedHashtags={[]}
          eventHashtags={[]}
          thirdPartyUrl={thirdPartyUrl}
          publicStatus={publicStatus}
          user={user}
          publishClipId={publishClipId}
          singleClipPublish={true}
          addSocialMediaData={addSocialMediaData}
          streamDetails={streamDetails}
          addPublishNotification={addPublishNotification}
          aspectRatio={filters?.aspectRatio || "16:9"}
          registerAryshareWebhook={registerAryshareWebhook}
          getSocialProfiles={getSocialProfiles}
        />
      ) : null}
      {isShowCsv && (
        <ShowCSV
          isShowCsv={isShowCsv}
          setIsShowCsv={setIsShowCsv}
          streamDetails={null}
          getCsvData={getCsvData}
          clipDetails={clip}
        />
      )}
      {copyOpen && (
        <CopyClip copyOpen={copyOpen} setCopyOpen={setCopyOpen} clip={clip} copyClipFun={copyClipFun} loder={loder} />
      )}
      {copyToChildModalOpen && (
        <CopyClipToChild
          copyToChildModalOpen={copyToChildModalOpen}
          setCopyToChildModalOpen={setCopyToChildModalOpen}
          clip={clip}
          fetchUserDetails={fetchUserDetails}
          copyClipToReviewer={copyClipToReviewer}
          streamDetails={streamDetails}
          fetchUsersByUserIds={fetchUsersByUserIds}
          allUsers={allUsers}
        />
      )}
      <EditClip
        editOpen={editOpen}
        setEditOpen={setEditOpen}
        clip={clip}
        loder={loder}
        editClips={editClips}
        publishClips={publishClips}
      />
      <DeleteModal
        modalIsOpen={delmodalOpen}
        setDeleteModalOpen={setDeleteModalOpen}
        userId={userId}
        loder={loder}
        deleteComanModel={deleteGridClip}
        header="Delete"
        content="Are you sure you want to delete?"
      />
      <TrimClip
        trimOpen={trimOpen}
        setTrimOpen={setTrimOpen}
        clip={clip}
        streamDetails={streamDetails}
        trimClip={trimClip}
      />
      <VideoSpeed
        videoSpeedOpen={videoSpeedOpen}
        setVideoSpeedOpen={setVideoSpeedOpen}
        streamDetails={streamDetails}
        trimClip={trimClip}
        clip={clip}
        loder={loder}
      />
      <GenerateTitle
        genTitleModalOpen={genTitleModalOpen}
        setGenTitleModalOpen={setGenTitleModalOpen}
        clip={clip}
        GenerateVideoTitle={GenerateVideoTitle}
      />
      <MetadataModal
        showMetadataDetailsModal={showMetadataDetailsModal}
        setShowMetadataDetailsModal={setShowMetadataDetailsModal}
      />
      <ShowClipTitle titleModalOpen={titleModalOpen} setTitleModalOpen={setTitleModalOpen} clip={clip} />
      {s3Open && (
        <UploadTOS3
          s3Open={s3Open}
          setS3Open={setS3Open}
          clip={clip}
          fetchStorage={fetchStorage}
          userId={userId}
          s3BucketPublish={s3BucketPublish}
          streamDetails={streamDetails}
          folderArray={folderArray}
          setFolderArray={setFolderArray}
          storage={storage}
          dumpOnS3={dumpOnS3}
          bucketCopy={bucketCopy}
          clientSetting={clientSetting}
          bulkS3BucketPublish={bulkS3BucketPublish}
          filters={filters}
          setLoder={setLoder}
          refreshClips={refreshClips}
          {...props}
        />
      )}
      {ftpOpen && (
        <UploadToFTP
          id={id}
          ftpList={ftpList}
          clip={clip}
          step={step}
          storage={storage}
          ftpPublish={ftpPublish}
          setFTPOpen={setFTPOpen}
          folderArray={folderArray}
          ftpOpen={ftpOpen}
          filters={filters}
          entityId={entityId}
        />
      )}
      <UploadToZee
        zeeOpen={zeeOpen}
        setZeeOpen={setZeeOpen}
        clip={clip}
        fetchStorage={fetchStorage}
        userId={userId}
        jsonBucketPublish={jsonBucketPublish}
        streamDetails={streamDetails}
        storage={storage}
        getCustomFields={getCustomFields}
        filters={filters}
        {...props}
      />
      <PublishToCMS
        publishToCMS={publishToCMS}
        setPublishTOCMS={setPublishTOCMS}
        clip={selectedClip}
        loder={loder}
        publishClips={publishClips}
        editClipsForCms={editClipsForCms}
        clientWebHookPublish={clientWebHookPublish}
        setLoder={setLoder}
        editClip={editClip}
        allClips={allClips}
        singleClipDetail={singleClipDetail}
        streamDetails={streamDetails}
        clientSetting={clientSetting}
        getCustomFields={getCustomFields}
        filters={filters}
      />
      <AlertDialog
        alertModel={isAlertOpen}
        content={alertMessage}
        oncloseAlertModel={() => {
          setIsAlertOpen(false);
        }}
      />
      <SocialMediaCaption
        captionModal={captionModal}
        setCaptionModal={setCaptionModal}
        createSocialMediaCaption={createSocialMediaCaption}
        clip={clip}
        loder={loder}
        setLoder={setLoder}
        streamDetails={streamDetails}
      />
      {openPublishThumbnailModal ? (
        <PublishThumbNailModal
          openPublishThumbnailModal={openPublishThumbnailModal}
          handlePublishThumbnailModal={handlePublishThumbnailModal}
          publishThumbnailClip={publishThumbnailClip}
          publishZeeThumbnails={publishZeeThumbnails}
          thumbnails={thumbnails}
          clientSetting={clientSetting}
        />
      ) : null}
    </>
  );
};
const mapDispatchToProps = {
  getDataFeedStatsPerformMetadata,
};

export default connect(null, mapDispatchToProps)(TableAction);
